import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-red-light-status',
  templateUrl: './red-light-status.component.html',
  styleUrls: ['./red-light-status.component.css']
})
export class RedLightStatusComponent {

  constructor(private readonly titleService: Title) {
    this.titleService.setTitle('Red Light Status | JSi360');
  }
}
